
  import DrawerMaterial from '@mui/material/Drawer';
import React from "react";
import close from '../../../assets/img/close.svg';
import styles from "./Drawer.module.scss";
import { DrawerProps } from "./Drawer.types";
  export const TEST_ID = "Drawer";
  
  export const  Drawer: React.FC<DrawerProps> = ({ title, children }) => {
    const [open, setOpen] = React.useState(true)
    
    const toggleDrawer = (open) => (event) => {
      if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
        return;
      }
  
      setOpen(false)
    };

    return (
      <div data-testid={TEST_ID}>
        <DrawerMaterial
            classes={{
              paper: styles.paper,
            }}
            BackdropProps={{ invisible: true, classes: { root: styles.root } }}            
            anchor="right"
            open={open}
            onClose={toggleDrawer(false)}>
              <div>
                {title && <div className={styles.drawer__header}>
                  <span className={styles.drawer__header__text}>{title}</span>
                  <span className={styles.drawer__header__cursor} onClick={toggleDrawer(false)}><img width={14} height={14} src={close} /></span>
                </div>}                
                {children}
              </div>
        </DrawerMaterial>
      </div>
    );
  }
  